import React from 'react';
import { Button, useDisclosure } from '@chakra-ui/react';

import { AssetType } from 'entities/assets/model';
import { AssetsDocument } from 'features/asset/add-assets-modal/graphql/queries.gen';
import { GetAssetsDocument } from 'pages/art-catalog/ui/ArtCatalogTable/queries.gen';
import { ButtonType, trackAssetDeleted } from 'shared/analytics';
import { useAppToast } from 'shared/hooks/toast';
import { TrashBinIcon } from 'shared/icons';
import { EntityDeletionAlert } from 'shared/ui/entity-deletion-alert';

import { useDeleteBodyMutation } from './queries.gen';

interface DeleteBodyButtonProps {
	id: string;
	onCompleted: () => void;
}

export const DeleteBodyButton: React.FC<DeleteBodyButtonProps> = ({
	id,
	onCompleted,
}) => {
	const { isOpen, onClose, onOpen } = useDisclosure();
	const toast = useAppToast();
	const [deleteBody, { loading }] = useDeleteBodyMutation({
		variables: { id },
		onCompleted: (data) => {
			toast({ title: 'Body deleted successfully', status: 'success' });
			onCompleted();
			trackAssetDeleted({
				type: AssetType.BODY,
				filename: data.deleteBody?.filename as string,
				link: data.deleteBody?.link as string,
			});
		},
		onError: () => toast({ title: 'Body was not deleted', status: 'error' }),
		refetchQueries: [AssetsDocument, GetAssetsDocument],
	});

	return (
		<>
			<Button
				disabled={loading}
				onClick={onOpen}
				leftIcon={<TrashBinIcon w={6} h={6} />}
			>
				Delete Body
			</Button>
			{isOpen && (
				<EntityDeletionAlert
					isOpen={isOpen}
					onClose={onClose}
					onSubmit={deleteBody}
					buttonName={ButtonType.DELETE_BODY}
					title="Body Deletion"
					description="If you delete this body, it can't be restored. Are you sure you want to continue?"
				/>
			)}
		</>
	);
};
